(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced) return;
  var desktop = window.matchMedia('(min-width: 750px)').matches;
  var INSTA = document.getElementById('shopify-section-165721376053ab7904');

  var sections = Array.prototype.slice.call(document.querySelectorAll('.twk-ow, .twk-feat, .twk-jnl'));
  if (INSTA) sections.push(INSTA);
  sections.forEach(function(s){ s.classList.add('twk-io-reveal'); });

  if (desktop) {
    document.querySelectorAll('.twk-ow .twk-ow__panel.is-active .twk-card').forEach(function(c){
      c.classList.add('twk-io-card');
    });
  }
  document.querySelectorAll('.twk-jnl .twk-jnl__feature, .twk-jnl .twk-jnl__card').forEach(function(c){
    c.classList.add('twk-io-card');
  });

  function staggerEls(els, base){
    if (!els.length) return;
    els.forEach(function(c, i){
      c.classList.add('twk-io-card');
      c.classList.remove('twk-io-in');
      c.style.transitionDelay = (base + Math.min(i, 10) * 90) + 'ms';
    });
    void els[0].offsetWidth;
    requestAnimationFrame(function(){
      els.forEach(function(c){ c.classList.add('twk-io-in'); });
    });
    setTimeout(function(){
      els.forEach(function(c){ c.style.transitionDelay = ''; });
    }, base + 10 * 90 + 1000);
  }

  function staggerPanel(panel, base){
    if (!desktop || !panel) return;
    staggerEls(Array.prototype.slice.call(panel.querySelectorAll('.twk-card')), base || 0);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        setTimeout(function(){
          el.classList.add('twk-io-in');
          if (el.classList.contains('twk-ow')) {
            staggerPanel(el.querySelector('.twk-ow__panel.is-active'), 260);
          }
          if (el.classList.contains('twk-jnl')) {
            staggerEls(Array.prototype.slice.call(el.querySelectorAll('.twk-jnl__feature, .twk-jnl__card')), 260);
          }
        }, 180);
      });
    }, { threshold: 0.12 });
    sections.forEach(function(s){ io.observe(s); });
  } else {
    sections.forEach(function(s){ s.classList.add('twk-io-in'); });
    document.querySelectorAll('.twk-io-card').forEach(function(c){ c.classList.add('twk-io-in'); });
  }

  document.addEventListener('click', function(ev){
    var t = ev.target.closest('[data-twk-tab]');
    if (!t) return;
    var root = t.closest('.twk-ow');
    if (!root) return;
    setTimeout(function(){
      staggerPanel(root.querySelector('.twk-ow__panel.is-active'), 60);
    }, 0);
  });
})();
